export const environment = {
  production: false,
  state: "local",
  baseUrl: "http://localhost:3000",
  CLIENT_PROTOCOL_ORIGIN: "http://localhost:4200",
  kakaoAppKey: "817d392bc09e745b075aa13978eb8825",
  nhn: {
    objectStorageContainer: "test",
  },
};
